import React from 'react';
import AddBookmark from 'components/Page/Toolbox/Bookmark/AddBookmark';
import HyperLink from 'components/Core/HyperLink';
import useExternalBanner from 'hooks/useExternalBanner';
import getBreakpointView from 'utils/getBreakpointView';
import rightArrow from 'images/right-arrow-gray.svg';
import rightArrowLight from 'images/right-arrow-lightgray.svg';
import forwardSlash from 'images/forward_slash.svg';
import forwardSlashWhite from 'images/forward_slash_white.svg';
import { Container, InnerContainer, ChildLink, ParentLink } from './styles';

const Breadcrumbs = ({
  breadcrumbs: initialBreadcrumbs,
  absoluteMode,
  simpleHeader,
  subNav,
  stickyWithoutHeader,
  theme,
  layout,
}) => {
  const isMobile = getBreakpointView(['xs']);
  const darkTheme = theme === 'dark';
  const { bannerHeight } = useExternalBanner();
  const breadcrumbs = initialBreadcrumbs?.filter(x => x !== false);

  const formatBreadcrumb = (breadcrumb, index) => {
    const singleParentPageMobile = breadcrumbs.length <= 1 && isMobile;

    const hasSubPage =
      !singleParentPageMobile && breadcrumbs.length > index + 1 && index !== breadcrumbs.length - 1;

    if (breadcrumb.url) {
      return (
        <HyperLink href={breadcrumb.url} key={`breadcrumb-${index}`}>
          <ParentLink darkTheme={darkTheme}>
            {singleParentPageMobile && (
              <img
                src={darkTheme ? rightArrow : rightArrowLight}
                className="breadcrumb--arrow reverse"
              />
            )}
            {breadcrumb.title}
            {breadcrumb.icon && <img src={breadcrumb.icon} className="breadcrumb--icon" />}
            {hasSubPage && (
              <img
                src={darkTheme ? forwardSlash : forwardSlashWhite}
                className="breadcrumb--arrow"
              />
            )}
          </ParentLink>
        </HyperLink>
      );
    }

    return (
      <ChildLink key={`breadcrumb-${index}`} darkTheme={darkTheme}>
        {breadcrumb.title}
        {breadcrumb.icon && <img src={breadcrumb.icon} className="breadcrumb--icon" />}
      </ChildLink>
    );
  };

  const MobileBreadcrumbs = () => (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div style={{ margin: '13px 0px 5px', display: 'flex', flexDirection: 'row' }}>
        {breadcrumbs.map((crumb, index) => {
          const hasNextCrumb =
            index !== breadcrumbs.length - 1 ||
            breadcrumbs.length === 1 ||
            breadcrumbs[breadcrumbs.length - 1].url;
          return hasNextCrumb && formatBreadcrumb(crumb, index);
        })}
      </div>
      {!breadcrumbs[breadcrumbs.length - 1].url && (
        <div>{formatBreadcrumb(breadcrumbs[breadcrumbs.length - 1], 0)}</div>
      )}
    </div>
  );

  const DesktopBreadcrumbs = () => (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      {breadcrumbs.map((crumb, index) => {
        return formatBreadcrumb(crumb, index);
      })}
    </div>
  );

  return (
    <Container
      className="breadcrumb--wrapper"
      absoluteMode={absoluteMode}
      simpleHeader={simpleHeader}
      subNav={subNav}
      stickyWithoutHeader={stickyWithoutHeader}
      bannerHeight={bannerHeight}
      layout={layout}
    >
      {breadcrumbs && (
        <InnerContainer layout={layout}>
          {!isMobile ? <DesktopBreadcrumbs /> : <MobileBreadcrumbs />}
          {layout === 'toolbox' && (
            <AddBookmark
              label={isMobile ? '' : 'Bookmark'}
              color={theme === 'dark' ? 'var(--neutral-text-color)' : 'var(--white-color)'}
            />
          )}
        </InnerContainer>
      )}
    </Container>
  );
};

export default Breadcrumbs;
